import { createSelector } from '@ngrx/store';

import * as fromCalculatedVariables from '../calculated-variable/calculated-variable.reducer';
import { selectDashboardState } from '../dashboard.selectors';

export const selectCalculatedVariableState = createSelector(
  selectDashboardState,
  (dashboard) => dashboard?.calculatedVariable
);

export const selectIsLoadingCalculatedVariables = createSelector(
  selectCalculatedVariableState,
  (calculatedVariableState) => calculatedVariableState?.loadingCalculatedVariables
);

export const selectCalculatedVariablesLoaded = createSelector(
  selectCalculatedVariableState,
  (calculatedVariableState) => calculatedVariableState?.calculatedVariablesLoaded
);

export const selectCalculatedVariables = createSelector(
  selectCalculatedVariableState,
  fromCalculatedVariables.selectAll
);
